import { createFileRoute } from '@tanstack/react-router'
// TODO: Put a rolodex-fetcher in the Tanstack context so it can be used in a beforeLoad
// eslint-disable-next-line boundaries/dependencies
import { useRolodexEntries } from 'features/rolodex'
import { RolodexEntryType } from 'gecko-types'
import React from 'react'
import { Route as LifecycleRoute } from 'routes/assets/(single_asset_destinations)/lifecycle'
import { Route as BaseUnitPageRoute } from 'routes/assets/(single_asset_destinations)/unit'
import { assetRoutingSearchParams } from 'routes/assets/-searchParams'

function RouteComponent() {
  const { useSearch, useNavigate } = Route

  const { siteId } = useSearch()

  const { siteConfigs, isLoading, hasEverLoaded } = useRolodexEntries(
    React.useMemo(
      () => ({
        type: RolodexEntryType.SITE_CONFIG,
        tags: { site: siteId },
        limit: 1,
      }),
      [siteId]
    )
  )

  const navigate = useNavigate()

  if (isLoading || !hasEverLoaded) {
    return null
  }

  if (siteConfigs.at(0)?.data.useAssetLifecycle) {
    navigate({
      to: LifecycleRoute.to,
      search: (prev) => prev,
      replace: true,
    })
    return null
  }

  navigate({
    to: BaseUnitPageRoute.to,
    search: (prev) => prev,
    replace: true,
  })
}

export const Route = createFileRoute('/assets/routing')({
  validateSearch: assetRoutingSearchParams,
  component: RouteComponent,
})
